import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  async subscribe(event) {
    event.preventDefault();

    const response = await fetch("/checkout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
      body: JSON.stringify({ price_id: event.params.priceId }),
    });

    const data = await response.json();

    window.location.href = data.url;
  }
}
